<template>
  <v-container
    class="ma-0 pa-0 white"
    fluid
    fill-height
  >
    <v-layout>
      <v-flex>
        <fullpage-loader
          message="טוען אנשי קשר..."
          v-if="loading"
        ></fullpage-loader>

        <div v-else>
          <v-expansion-panel
            class="elevation-0"
          >
            <v-expansion-panel-content
              v-for="contact in contacts"
              :key="contact._id"
            >
              <template v-slot:header>
                <span class="title">{{ contact.name }}</span>
              </template>
              <contact
                :contact="contact"
                :resource="$store.state.resources.eventContact"
                :parent-resource="$store.state.resources.event"
                :parent-id="eventId"
                :roles="['ADMIN', 'EVENT_MANAGER', 'RESEARCHER']"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-btn
            small
            @click="create"
            class="mt-3"
            v-if="shouldShow(['ADMIN', 'EVENT_MANAGER'], user)"
          >
            <v-icon>add</v-icon> הוספת איש קשר
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import FullpageLoader from "../../FullpageLoader.vue";
import Contact from "../../Contact.vue";
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";
import { getApi } from "@/api";

export default {
  data() {
    return {
      loading: true,
      compId: null,
      activeContactId: null,
      headers: [
        {
          text: "שם",
          align: "right",
          value: "name"
        },
        { text: "גיל", align: "right", value: "age" },
        { text: "מס׳ זהות", align: "right", value: "id" },
        // {
        //   text: "עריכה",
        //   align: "left",
        //   sortable: false,
        //   roles: ["ADMIN", "EVENT_MANAGER"]
        // },
        {
          text: "מחיקה",
          align: "left",
          sortable: false,
          roles: ["ADMIN", "EVENT_MANAGER"]
        }
      ]
    };
  },

  computed: {
    contacts() {
      // Get event IDs to show from store
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      
      if (eventIdsToShow.length === 1) {
        // Single event mode
        return this.$store.getters["contacts/eventContacts"](this.$route.params.id);
      } else {
        // Multiple events mode (כולם) - get contacts from all events
        const allContacts = [];
        eventIdsToShow.forEach(eventId => {
          const eventContacts = this.$store.getters["contacts/eventContacts"](eventId);
          if (eventContacts && eventContacts.length > 0) {
            allContacts.push(...eventContacts);
          }
        });
        return allContacts;
      }
    },
    // contact() {
    //   return this.$store.state.entities.contacts[this.contactId];
    // },
    resource() {
      return this.$store.state.resources.eventContact;
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    }
  },
  methods: {
    shouldShow,
    showContact(id) {
      this.activeContactId = id;
    },
    fetchContacts() {
      this.loading = true;
      this.removing = [];
      
      // Get event IDs to show from store
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      console.log('Contacts fetchContacts - eventIdsToShow:', eventIdsToShow);
      
      this.$store
        .dispatch("API_GET", {
          url: "/contacts",
          entityType: "contact",
          schema: "contactListSchema",
          params: {
            q: JSON.stringify({ event: { $in: eventIdsToShow } })
          },
          replace: true
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      // Check if we're in כולם mode (multiple events)
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      const isAllEventsMode = eventIdsToShow && eventIdsToShow.length > 1;

      if (isAllEventsMode) {
        // Create contact for all events in the ARAN
        console.log('Contacts create - creating for all events:', eventIdsToShow);
        
        // Create multiple entities for all events
        const entities = eventIdsToShow.map(eventId => ({
          _id: generateId(),
          event: eventId
        }));

        // Open dialog with multiple entities
        this.edit({
          entity: entities[0], // Use first one for the dialog
          isNew: true,
          createForAllEvents: true,
          allEventIds: eventIdsToShow
        });
      } else {
        // Create contact for single event (normal mode)
        let newEntity = { _id: generateId(), event: this.$route.params.id };
        this.edit({
          entity: newEntity,
          isNew: true
        });
      }
    },
    edit({ entity, entityId, isNew = false, createForAllEvents = false, allEventIds = null }) {
      if (!entity) {
        entity = this.$store.state.entities[this.resource.entityType][entityId];
      }
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: this.resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.resource,
        isNew,
        createForAllEvents,
        allEventIds
      });
      this.entityEditDialog = true;
    },
    remove(id) {
      this.$confirm("האם למחוק " + this.resource.name).then(res => {
        if (!res) {
          return;
        }
        this.removeConfirmed(id);
      });
    },
    removeConfirmed(id) {
      this.removing[id] = true;
      this.$store
        .dispatch("REMOVE_ENTITY", {
          url: this.resource.endpoint,
          entityType: this.resource.entityType,
          id
        })
        .then(() => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: this.resource.name + " נמחק/ה",
            color: "success"
          });
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.removing[id] = false;
        });
    }
  },
  mounted() {
    this.fetchContacts();
    this.compId = generateId();
    
    // Listen for global refetch event
    this.$bus.$on('refetch-all-data', () => {
      console.log('Contacts - received global refetch event');
      this.fetchContacts();
    });
  },

  watch: {
    // Refetch when event IDs to show change
    '$store.state.events.eventIdsToShow': {
      handler(newVal, oldVal) {
        console.log('Contacts watcher - eventIdsToShow changed from:', oldVal, 'to:', newVal);
        this.fetchContacts();
      },
      deep: true,
      immediate: true
    },
    // Watch for route changes to refetch data when switching events
    '$route.params.id': {
      handler(newEventId) {
        if (newEventId && newEventId !== this.$route.params.id) {
          this.fetchContacts();
        }
      },
      immediate: true
    },
    contacts: function(val, oldVal) {
      if (val.length === 1) {
        this.activeContactId = val[0]._id;
      }
    }
  },

  beforeDestroy() {
    // Clean up global event listener
    this.$bus.$off('refetch-all-data');
  },

  props: ["eventId"],

  components: {
    FullpageLoader,
    Contact
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.contact-container .v-toolbar__content {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/events/modules/Contacts.vue